import type { InsurancePolicy } from '@/types/insurancePolicy';

export enum PaymentMethod {
  SELF_PAY = 'self-pay',
  INSURANCE = 'insurance',
  RESEARCH = 'research',
  FREE_TRIAL = 'free trial'
}

export interface Props {
  payment_type: string;
  insurance: InsurancePolicy;
  insuranceIneligible: boolean;
}
